export default __webpack_public_path__ + "locales/cs/EmptyTrashDialog.json?hash=bf0d919335b87d98e771c52f91b8081b";